import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaWallet, FaMoneyBill, FaArrowLeft, FaCheckCircle, FaDownload } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import BankTransferPayment from './BankTransferPayment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const PaymentMethodSelect = ({ userId: propUserId, formData, amount, onBack, onSuccess }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const locationState = location.state || {};
    
    // Get userId from multiple sources
    const passedUserId = locationState.userId;
    const userId = propUserId || passedUserId || localStorage.getItem('userId') || sessionStorage.getItem('userId');
    
    const passedFormData = locationState.formData || {};
    
    // Use passed data from navigation if available, otherwise use props
    const finalFormData = Object.keys(passedFormData).length > 0 ? passedFormData : formData;
    
    const [selectedMethod, setSelectedMethod] = useState('');
    const [loading, setLoading] = useState(false);
    const [showBankTransfer, setShowBankTransfer] = useState(false);
    const [disclaimerAgreed, setDisclaimerAgreed] = useState(false);
    const [generatingPDF, setGeneratingPDF] = useState(false);

    // Debug: Log the received data
    console.log('PaymentMethodSelect - propUserId:', propUserId);
    console.log('PaymentMethodSelect - passedUserId from state:', passedUserId);
    console.log('PaymentMethodSelect - final userId:', userId);
    console.log('PaymentMethodSelect - Received formData:', formData);
    console.log('PaymentMethodSelect - Passed formData from navigation:', passedFormData);
    console.log('PaymentMethodSelect - Final formData:', finalFormData);

    // Get user details from finalFormData
    const userName = finalFormData?.name || 
                    formData?.name ||
                    localStorage.getItem('userName') ||
                    '_____________';
    
   // In the component, ensure userShowId is a string
const userShowId = String(finalFormData?.show_id || 
                   userId || 
                   localStorage.getItem('userShowId') ||
                   '_____________');
    const userEmail = finalFormData?.email || 
                      formData?.email ||
                      localStorage.getItem('userEmail') ||
                      'Not provided';
    
    const userPhone = finalFormData?.contact || 
                      finalFormData?.phone ||
                      formData?.contact ||
                      formData?.phone ||
                      localStorage.getItem('userPhone') ||
                      'Not provided';

    // Signature is automatically set to user's name (not editable)
    const signature = userName;

    // Store in localStorage for persistence
    useEffect(() => {
        if (userId && userId !== '_____________') {
            localStorage.setItem('userId', userId);
            sessionStorage.setItem('userId', userId);
        }
        if (userName && userName !== '_____________') {
            localStorage.setItem('userName', userName);
        }
        if (userShowId && userShowId !== '_____________') {
            localStorage.setItem('userShowId', userShowId);
        }
        if (userEmail && userEmail !== 'Not provided') {
            localStorage.setItem('userEmail', userEmail);
        }
        if (userPhone && userPhone !== 'Not provided') {
            localStorage.setItem('userPhone', userPhone);
        }
    }, [userId, userName, userShowId, userEmail, userPhone]);

    // Validate userId before proceeding
    useEffect(() => {
        if (!userId) {
            console.error('No userId found! Please check navigation data.');
            toast.error('Session expired. Please login again.');
            // Optionally redirect to login or registration
            // navigate('/registration');
        }
    }, [userId, navigate]);

    const paymentMethods = [
        { 
            id: 'esewa', 
            name: 'Esewa', 
            image: 'https://cdn.esewa.com.np/ui/images/logos/esewa-icon-large.png',
            color: 'bg-green-50', 
            borderColor: 'border-green-500', 
            description: 'Pay with Esewa wallet' 
        },
        { 
            id: 'khalti', 
            name: 'Khalti', 
            image: 'https://cdn.aptoide.com/imgs/b/2/c/b2c3c82e2890203b7a4b0cfb188b3f71_icon.png',
            color: 'bg-purple-50', 
            borderColor: 'border-purple-500', 
            description: 'Pay with Khalti wallet' 
        },
        { 
            id: 'hbl', 
            name: 'Card Payment', 
            image: 'https://e7.pngegg.com/pngimages/363/177/png-clipart-visa-mastercard-logo-visa-mastercard-computer-icons-visa-text-payment-thumbnail.png',
            color: 'bg-red-50', 
            borderColor: 'border-red-500', 
            description: 'Pay with Visa / mastercard' 
        },
        { 
            id: 'connectips', 
            name: 'ConnectIPS', 
            image: 'https://play-lh.googleusercontent.com/l2NwpHebHN7ZwsyqxMhe3Ke75VC-vN8o5Xyz9cVkE3ES-o_lviOiFStNrCeo_BUtsLo_',
            color: 'bg-blue-50', 
            borderColor: 'border-blue-500', 
            description: 'Pay via bank account' 
        },
        { 
            id: 'bank', 
            name: 'QR AND Bank Transfer', 
            image: 'https://thehrmnepal.com/wp-content/uploads/2023/08/bank-864x1024.jpg',
            color: 'bg-gray-50', 
            borderColor: 'border-gray-500', 
            description: 'Direct QR OR bank transfer' 
        }
    ];

    const generateAgreementPDF = async () => {
        if (!disclaimerAgreed) {
            toast.warning('कृपया पहिले सहमति दिनुहोस् | Please agree to the disclaimer first');
            return;
        }

        setGeneratingPDF(true);
        
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.top = '-9999px';
        tempDiv.style.left = '-9999px';
        tempDiv.style.width = '800px';
        tempDiv.style.backgroundColor = 'white';
        tempDiv.style.padding = '40px';
        tempDiv.style.fontFamily = 'Arial, "Noto Sans Nepali", sans-serif';
        
        const currentDate = new Date().toLocaleDateString('ne-NP', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        
        tempDiv.innerHTML = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: 'Arial', 'Noto Sans Nepali', sans-serif;
                        line-height: 1.5;
                        color: #333;
                    }
                    .header {
                        background: linear-gradient(135deg, #dc2626, #1e3a8a);
                        padding: 30px;
                        text-align: center;
                        color: white;
                        margin-bottom: 30px;
                    }
                    .header h1 {
                        font-size: 28px;
                        margin-bottom: 10px;
                    }
                    .header p {
                        font-size: 18px;
                    }
                    .user-info {
                        margin-bottom: 20px;
                        padding: 15px;
                        background: #f3f4f6;
                        border-radius: 8px;
                    }
                    .user-info div {
                        margin-bottom: 8px;
                    }
                    .section-title {
                        font-size: 18px;
                        font-weight: bold;
                        color: #dc2626;
                        margin: 20px 0 15px 0;
                        padding-bottom: 5px;
                        border-bottom: 2px solid #dc2626;
                    }
                    .clause {
                        margin-bottom: 15px;
                        padding: 10px;
                        background: #f9fafb;
                        border-radius: 5px;
                    }
                    .clause-nep {
                        font-size: 14px;
                        font-weight: bold;
                        margin-bottom: 8px;
                        color: #1f2937;
                    }
                    .clause-eng {
                        font-size: 12px;
                        color: #6b7280;
                        border-top: 1px solid #e5e7eb;
                        padding-top: 8px;
                    }
                    .refund-box {
                        background: #fff6e8;
                        border-left: 4px solid #f97316;
                        padding: 15px;
                        margin: 15px 0;
                        border-radius: 8px;
                    }
                    .declaration {
                        background: #fef3c7;
                        padding: 15px;
                        margin: 15px 0;
                        border-radius: 8px;
                        border: 1px solid #fbbf24;
                    }
                    .signature-area {
                        margin: 25px 0;
                        padding: 15px;
                        border-top: 1px solid #d1d5db;
                    }
                    .footer {
                        margin-top: 30px;
                        padding-top: 15px;
                        text-align: center;
                        font-size: 10px;
                        color: #9ca3af;
                        border-top: 1px solid #e5e7eb;
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <h1>BIHEBARI</h1>
                    <p>Declaration & Agreement | घोषणा र सम्झौता</p>
                </div>
                
                <div class="user-info">
                    <div><strong>Date (मिति):</strong> ${currentDate}</div>
                    <div><strong>Name (नाम):</strong> ${userName}</div>
                    <div><strong>Show ID (शो आईडी):</strong> BB${userShowId}</div>
                    <div><strong>Email (इमेल):</strong> ${userEmail}</div>
                    <div><strong>Phone (फोन):</strong> ${userPhone}</div>
                </div>
                
                <div class="section-title">📜 Terms & Conditions (सर्तहरू)</div>
                
                <div class="clause">
                    <div class="clause-nep">१. विहेवारीले हजुरहरुले उपलब्ध गराएको विवरण र मापदण्ड अनुसार आफ्नो डाटाबेसबाट उपयुक्त पात्र खोज्ने जिम्मेवारी लिन्छ। यो खोज कार्यका लागि लाग्ने समय, प्रविधि र कर्मचारीको मेहेनत बापत शुरुमै दर्ता शुल्क रु ४००० लाग्नेछ।</div>
                    <div class="clause-eng">Bihebari takes responsibility to search suitable matches from our database based on criteria. An upfront registration fee of NPR 4,000 is charged for technology, staff efforts and search process.</div>
                </div>
                
                <div class="clause">
                    <div class="clause-nep">२. दर्ता शुल्क बुझाइसके पछि ४ महिना भित्र कुनै पनि बहानामा "रकम फिर्ता" (Refund) माग्न पाइने छैन।</div>
                    <div class="clause-eng">Once registration fee is paid, a "Refund" cannot be claimed on any excuses within 4 months.</div>
                </div>
                
                <div class="clause">
                    <div class="clause-nep">३. गोपनीयतालाई ध्यानमा राखी हजुरहरुको व्यक्तिगत विवरण र फोटोहरू पूर्ण रूपमा सुरक्षित राखिनेछ र केवल उपयुक्त र गम्भीर पात्रहरूलाई मात्र देखाइनेछ।</div>
                    <div class="clause-eng">We guarantee full privacy for your personal information and photographs; they will only be disclosed to compatible and genuine matches.</div>
                </div>
                
                <div class="clause">
                    <div class="clause-nep">४. विवाह निश्चित भएपछि सेवा शुल्क ३०,००० लाग्ने छ।</div>
                    <div class="clause-eng">Service Charge of Rs. 30,000/- is liable after marriage is fixed.</div>
                </div>
                
                <div class="clause">
                    <div class="clause-nep">५. यदी विहेवारीबाट विवाह भएको खण्डमा विहे भएको १ महिनासम्म पनि सेवा शुल्क नतिरेमा वा शुल्क तिर्नुपर्छ भनी जानकारी गराउँदा पनि सम्पर्क विहीन भएमा, संस्थाले मेरो फोटो र विवरण सार्वजनिक गर्न पाउने पूर्ण अधिकार राख्दछ। यस्तो अवस्थामा संस्थाले चालेको कदम विरुद्ध मैले कुनै पनि कानुनी उजुरी वा दाबी गर्ने छैन ।</div>
                    <div class="clause-eng">If you get married via Bihebari and service fee not settled within one month of marriage, or unreachable regarding payment, the institution reserves right to publish my photo and details publicly. I waive legal action/complaints.</div>
                </div>
                
                <div class="section-title">💰 Refund Policy (पैसा फिर्ता नीति)</div>
                
                <div class="refund-box">
                    <div class="clause-nep">यदि दर्ता भएको ४ महिनासम्म पनि 'विहेवारी' ले हजुरको मापदण्ड अनुसारको एक (१) जोडीसँग पनि कुरा गराउन सकेन भने निम्न सर्तमा पैसा फिर्ता:</div>
                    <div class="clause-nep">• फिर्ता रकम: प्रशासनिक खर्च र मेहेनत बापत रु. २००० कट्टा गरी रु. २,०००/- (दुई हजार) फिर्ता हुनेछ ।</div>
                    <div class="clause-nep">• फिर्ता समय: ४ महिना पूरा भएको ७ दिनभित्र ।</div>
                    <div class="clause-nep">🔔 नोट: यदि उपयुक्त पात्रसँग कुराकानी अगाडि बढेको छ भने फिर्ता लागू हुँदैन। रु. ४००० मा अधिकतम ४ जना सम्भावित पात्रसँग सम्पर्क गर्न सकिन्छ। नम्बर आदानप्रदान भएपछि मात्र 'म्याच' गणना हुन्छ।</div>
                    <div class="clause-eng" style="margin-top: 10px;"><strong>English:</strong> If Bihebari cannot facilitate conversation with even a single partner (matching criteria) within 4 months: Refund amount NPR 2,000 after deducting NPR 2,000 admin cost. Refund within 7 days after 4 month period. Note: Refund void if suitable match conversation started. Up to 4 matches within registration fee. Contact exchange = Match counted.</div>
                </div>
                
                <div class="section-title">⚖️ Legal Declaration (कानुनी स्वघोषणा)</div>
                
                <div class="declaration">
                    <div class="clause-nep">म श्री "${userName}" BB${userShowId} ले माथि दिएका सबै विवरण कानुनी रूपमा सत्य छ । यदि भविष्यमा कुनै कानुनी त्रुटि भेटिएमा त्यसको पूर्ण जिम्मेवार म आफै हुनेछु र विहेवारीलाई कुनै दोष दिने छैन।</div>
                    <div class="clause-eng" style="margin-top: 10px;">I, Mr./Ms. "${userName}" BB${userShowId}, hereby declare that all information provided above is legally true. If any legal discrepancy is found in the future, I shall be fully responsible and will not hold Bihebari liable.</div>
                </div>
                
                <div class="signature-area">
                    <div><strong>Signature (हस्ताक्षर):</strong> ${signature}</div>
                    <div style="margin-top: 10px;"><strong>Signed Name (हस्ताक्षरकर्ताको नाम):</strong> ${signature}</div>
                    <div style="margin-top: 15px; font-style: italic; font-size: 12px;">I hereby confirm that I have read, understood, and agreed to all the above terms, conditions, refund policy, and legal declaration.</div>
                    <div style="margin-top: 5px; font-style: italic; font-size: 12px;">मैले माथिका सबै सर्तहरू, पैसा फिर्ता नीति, र कानुनी स्वघोषणा पढेको, बुझेको, र स्वीकार गरेको पुष्टि गर्दछु।</div>
                </div>
                
                <div class="footer">
                    Generated on: ${currentDate} | Bihebari Agreement - Legally Binding Document
                </div>
            </body>
            </html>
        `;
        
        document.body.appendChild(tempDiv);
        
        try {
            const canvas = await html2canvas(tempDiv, {
                scale: 2,
                logging: false,
                useCORS: true,
                backgroundColor: '#ffffff'
            });
            
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });
            
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            
            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            
            pdf.save(`Bihebari_Agreement_${userName.replace(/\s/g, '_')}_BB${userShowId}.pdf`);
            toast.success('Agreement downloaded successfully! | सम्झौता सफलतापूर्वक डाउनलोड गरियो!');
        } catch (error) {
            console.error('PDF generation error:', error);
            toast.error('Failed to generate PDF. Please try again.');
        } finally {
            document.body.removeChild(tempDiv);
            setGeneratingPDF(false);
        }
    };

    const handleMethodSelect = (methodId) => {
        setSelectedMethod(methodId);
    };

  const handleProceedToPay = async () => {
    if (!selectedMethod) {
        toast.error('Please select a payment method');
        return;
    }

    if (!disclaimerAgreed) {
        toast.error('Please agree to the disclaimer before proceeding');
        return;
    }

    // Get the numeric userId (remove BB prefix if present)
    let numericUserId = userId;
    if (typeof userId === 'string' && userId.startsWith('BB')) {
        numericUserId = userId.replace('BB', '');
    }
    
    // Also try to get from userShowId if userId is not numeric
    if (!numericUserId || isNaN(parseInt(numericUserId))) {
        let showIdNumeric = userShowId;
        if (typeof showIdNumeric === 'string' && showIdNumeric.startsWith('BB')) {
            showIdNumeric = showIdNumeric.replace('BB', '');
        }
        numericUserId = parseInt(showIdNumeric);
    }

    console.log('=== PAYMENT DEBUG ===');
    console.log('Original userId:', userId);
    console.log('Numeric userId being used:', numericUserId);
    console.log('userShowId:', userShowId);
    console.log('Name:', userName);
    console.log('=====================');

    if (!numericUserId || isNaN(parseInt(numericUserId))) {
        toast.error('Invalid user ID. Please refresh and try again.');
        return;
    }

    const agreementData = {
        name: userName,
        showId: userShowId,
        signature: signature,
        email: userEmail,
        phone: userPhone,
        userId: numericUserId,
        agreedAt: new Date().toISOString(),
        disclaimer: `म श्री "${userName}" BB${userShowId} ले माथि दिएका सबै विवरण कानुनी रूपमा सत्य छ । यदि भविष्यमा कुनै कानुनी त्रुटि भेटिएमा त्यसको पूर्ण जिम्मेवार म आफै हुनेछु र विहेवारीलाई कुनै दोष दिने छैन।\n\nI, Mr./Ms. "${userName}" BB${userShowId}, hereby declare that all information provided above is legally true. If any legal discrepancy is found in the future, I shall be fully responsible and will not hold Bihebari liable.`
    };
    
    localStorage.setItem('userAgreement', JSON.stringify(agreementData));

    setLoading(true);

    console.log('Initiating payment for user:', numericUserId, 'Amount:', amount);

    if (selectedMethod === 'esewa') {
        try {
            const response = await axios.post('https://app.bihebari.com.np/api/payment/esewa/initiate', {
                user_id: numericUserId,  // Use numeric userId
                amount: amount || 4000,
                signature: signature,
                agreed: disclaimerAgreed,
                user_name: userName,
                show_id: userShowId
            });

            if (response.data.success) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = response.data.actionUrl;
                form.target = '_self';
                
                Object.keys(response.data.formData).forEach(key => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = response.data.formData[key];
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
            } else {
                toast.error('Failed to initiate Esewa payment');
                setLoading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to initiate Esewa payment');
            setLoading(false);
        }
    } 
    else if (selectedMethod === 'khalti') {
        try {
            const response = await axios.post('https://app.bihebari.com.np/api/payment/khalti/initiate', {
                user_id: numericUserId,  // Use numeric userId
                amount: amount || 4000,
                signature: signature,
                agreed: disclaimerAgreed,
                user_name: userName,
                show_id: userShowId
            });

            if (response.data.success && response.data.payment_url) {
                window.location.href = response.data.payment_url;
            } else {
                toast.error(response.data?.message || 'Failed to initiate Khalti payment');
                setLoading(false);
            }
        } catch (error) {
            console.error('Khalti error:', error);
            toast.error(error.response?.data?.message || 'Failed to initiate Khalti payment');
            setLoading(false);
        }
    }
    else if (selectedMethod === 'hbl') {
        try {
            const response = await axios.post('https://app.bihebari.com.np/api/payment/hbl/initiate', {
                user_id: numericUserId,  // Use numeric userId
                amount: amount || 4000,
                signature: signature,
                agreed: disclaimerAgreed,
                user_name: userName,
                show_id: userShowId
            });

            if (response.data.success && response.data.redirect_url) {
                window.location.href = response.data.redirect_url;
            } else {
                toast.error(response.data?.message || 'Failed to initiate HBL payment');
                setLoading(false);
            }
        } catch (error) {
            console.error('HBL error:', error);
            toast.error(error.response?.data?.message || 'Failed to initiate HBL payment');
            setLoading(false);
        }
    }
  else if (selectedMethod === 'connectips') {
    try {
        const response = await axios.post('https://app.bihebari.com.np/api/payment/connectips/initiate', {
            user_id: numericUserId,
            package_id: 'REGISTRATION',
            amount: amount || 4000,
            pay_method: 'connectips',
            signature: String(signature || ''),
            agreed: disclaimerAgreed,
            user_name: String(userName || ''),
            show_id: String(userShowId || '')
        }, {
            responseType: 'text'
        });
        
        document.open();
        document.write(response.data);
        document.close();
    } catch (error) {
        console.error('ConnectIPS error:', error);
        toast.error(error.response?.data?.message || 'Failed to initiate ConnectIPS payment');
        setLoading(false);
    }
}
    else if (selectedMethod === 'bank') {
        setShowBankTransfer(true);
        setLoading(false);
    }
    else {
        toast.info(`${selectedMethod} payment integration coming soon`);
        setLoading(false);
    }
};

    if (showBankTransfer) {
        return (
            <BankTransferPayment
                userId={userId}
                amount={amount}
                onBack={() => {
                    setShowBankTransfer(false);
                    setSelectedMethod('');
                }}
                onSuccess={() => {
                    if (onSuccess) onSuccess();
                }}
            />
        );
    }

    return (
        <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="p-6 md:p-8">
                    <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
                        <div className="flex items-center space-x-2">
                            <FaWallet className="text-indigo-600 text-xl" />
                            <h2 className="text-2xl font-bold text-gray-800">Select Payment Method</h2>
                        </div>
                        <button
                            onClick={generateAgreementPDF}
                            disabled={!disclaimerAgreed || generatingPDF}
                            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition shadow-md ${
                                disclaimerAgreed && !generatingPDF
                                    ? 'bg-red-600 hover:bg-red-700 text-white cursor-pointer' 
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            {generatingPDF ? (
                                <>
                                    <div className="w-4 h-4 border-t-2 border-white rounded-full animate-spin"></div>
                                    <span>Generating PDF...</span>
                                </>
                            ) : (
                                <>
                                    <FaDownload />
                                    <span>Download Agreement (PDF)</span>
                                </>
                            )}
                        </button>
                    </div>

                    <div className="mb-6 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-xl">
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Registration Amount:</span>
                            <span className="text-2xl font-bold text-green-600">Rs. {amount || 4000}</span>
                        </div>
                    </div>

                    {/* User Info Summary */}
                    <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl">
                        <h3 className="font-semibold text-gray-700 mb-2">Registration Information</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                            <div><strong>Name:</strong> {userName}</div>
                            <div><strong>ID:</strong> BB{userShowId}</div>
                            <div><strong>Email:</strong> {userEmail}</div>
                            <div><strong>Phone:</strong> {userPhone}</div>
                        </div>
                    </div>

                   {/* Disclaimer Section */}
                    <div className="mb-6 p-4 border-2 border-amber-300 rounded-xl bg-amber-50">
                        <div className="mb-3">
                            <p className="text-gray-800 font-medium text-sm leading-relaxed whitespace-pre-line">
                                {`म श्री "${userName}" BB${userShowId} ले माथि दिएका सबै विवरण कानुनी रूपमा सत्य छ । यदि भविष्यमा कुनै कानुनी त्रुटि भेटिएमा त्यसको पूर्ण जिम्मेवार म आफै हुनेछु र विहेवारीलाई कुनै दोष दिने छैन।

I Mr./Ms. "${userName}" BB${userShowId}, hereby declare that all information provided above is legally true. If any legal discrepancy is found in the future, I shall be fully responsible and will not hold Bihebari liable`}
                            </p>
                        </div>
                        
                        <div className="border-t border-amber-200 pt-3 mt-2">
                            <label className="flex items-center space-x-3 mb-3 cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={disclaimerAgreed}
                                    onChange={(e) => setDisclaimerAgreed(e.target.checked)}
                                    className="w-5 h-5 text-amber-600 rounded focus:ring-amber-500"
                                />
                                <span className="text-gray-700 font-medium">
                                    माथिको कानुनी विवरणमा सहमत छु | I agreed and accepted all the terms and conditions.
                                </span>
                            </label>
                            
                            <div className="mt-3">
                                <label className="block text-gray-700 font-medium mb-2">
                                    हस्ताक्षर (Signature)
                                </label>
                                <div className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg bg-gray-100 text-gray-700">
                                    {signature}
                                </div>
                                <p className="text-xs text-gray-500 mt-1">
                                    हस्ताक्षर स्वतः तपाईंको नामबाट भरिन्छ | Signature is automatically set to your name
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-4 mb-8">
                        {paymentMethods.map((method) => (
                            <div
                                key={method.id}
                                onClick={() => !disclaimerAgreed ? toast.warning('कृपया पहिले कानुनी विवरणमा सहमति दिनुहोस्') : handleMethodSelect(method.id)}
                                className={`border-2 rounded-xl p-4 cursor-pointer transition-all duration-300 ${
                                    !disclaimerAgreed && 'opacity-50'
                                } ${
                                    selectedMethod === method.id
                                        ? `${method.borderColor} ${method.color} shadow-lg`
                                        : 'border-gray-200 hover:border-indigo-300'
                                }`}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 flex items-center justify-center">
                                            <img 
                                                src={method.image} 
                                                alt={method.name}
                                                className="max-w-full max-h-full object-contain"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"%3E%3Crect x="2" y="4" width="20" height="16" rx="2"%3E%3C/rect%3E%3Cpath d="M8 12h8"%3E%3C/path%3E%3C/svg%3E';
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-800">{method.name}</h3>
                                            <p className="text-sm text-gray-500">{method.description}</p>
                                        </div>
                                    </div>
                                    {selectedMethod === method.id && (
                                        <FaCheckCircle className="text-indigo-600 text-xl" />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="flex justify-between pt-4">
                        <button
                            type="button"
                            onClick={onBack}
                            className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition flex items-center space-x-2"
                        >
                            <FaArrowLeft />
                            <span>Back</span>
                        </button>
                        <button
                            onClick={handleProceedToPay}
                            disabled={loading || !selectedMethod || !disclaimerAgreed}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <>
                                    <div className="w-5 h-5 border-t-2 border-white rounded-full animate-spin"></div>
                                    <span>Processing...</span>
                                </>
                            ) : (
                                <>
                                    <FaMoneyBill />
                                    <span>Proceed to Pay Rs. {amount || 4000}</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethodSelect;